
import SETTINGS from 'settings'

export function lang() {
    return SETTINGS.url_params[ 'lang' ] || SETTINGS.fallback_language || 'eng'
}



// WEBPACK FOOTER //
// ./src/library/lang.es6